// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2k5ML","header":"MessagesList_header__3crpR","chat":"MessagesList_chat__2BLR_"};